export default "__VITE_ASSET__f32dcdb9__"